import { render, staticRenderFns } from "./workflow-restrict-user.vue?vue&type=template&id=5806866d&"
import script from "./workflow-restrict-user.vue?vue&type=script&lang=js&"
export * from "./workflow-restrict-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports